import PropTypes from 'prop-types'

import { Info } from '@/components/Icons'
import TooltipTrigger from '@/components/Tooltip/TooltipTrigger'

import './index.scss'

const Header = ({ title, children, className, titleToolTip }: any) => (
  <div className={`card__header ${className}`}>
    <div className="card__title">
      {!!title && title}
      {!!titleToolTip && (
        <TooltipTrigger overlay={titleToolTip}>
          <span className="tooltip-icon">{<Info />}</span>
        </TooltipTrigger>
      )}
    </div>

    {children}
  </div>
)

Header.displayName = 'Header'

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  titleToolTip: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

Header.defaultProps = {
  children: null,
  className: '',
  title: null,
  titleToolTip: null
}

export default Header
